import { cn } from '@/lib/utils.js';
import { type InputHTMLAttributes, forwardRef } from 'react';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, error, ...props }, ref) => {
    return (
      <input
        type={type}
        aria-invalid={error === true ? true : undefined}
        className={cn(
          'flex h-10 w-full rounded-[var(--radius-input)] border px-3 py-2 text-sm',
          'bg-[var(--color-qup-bg-card-dark)] text-[var(--color-qup-text-dark)]',
          'placeholder:text-[var(--color-qup-text-muted)]',
          'transition-all duration-200',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-qup-primary)]',
          'disabled:cursor-not-allowed disabled:opacity-50',
          error === true
            ? 'border-[var(--color-qup-error)]'
            : 'border-[var(--color-qup-border-dark)]',
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';
